export const SET_FORMATS = 'SET_FORMATS';
export const SET_MESSAGES = 'SET_MESSAGES';

export type LocaleModule =
    | 'accessibility'
    | 'activity'
    | 'anonymous'
    | 'authorized-anonymous'
    | 'center-sign-in'
    | 'chat-room'
    | 'cluster'
    | 'courses'
    | 'csi-kiosk'
    | 'dashboard'
    | 'evaluations'
    | 'exams'
    | 'global'
    | 'lleap-generated'
    | 'lleap'
    | 'lms'
    | 'paging'
    | 'participant-reports'
    | 'participant-results'
    | 'profile'
    | 'remote-exams'
    | 'reports'
    | 'samaritan'
    | 'scenarios'
    | 'schedule'
    | 'sessions'
    | 'sps'
    | 'system-setup'
    | 'users';
